import React from 'react'

const UnknownContent = () => {
    return (
        <div>
            <h1 className="modal-heading">Unknown</h1>
            <p>
                Scanners have detected that there's something here. We'll need
                to dispatch a ship to find out more.
            </p>
        </div>
    )
}

export default UnknownContent
